(ns frontend.view.data-import.steps.success
  (:require [frontend.bootstrap.components :as rbs]
            [common.localization :as loc]
            [frontend.view.data-import.db :as db]
            [frontend.routing :as routing]
            [ui.components.button.view :as button])
)

(defn view [props]
  [:div
   {:class "px-4"}
   [:div
    {:class-name "flex flex-col gap-4 success-message"}
    [:div
      [:p
       {:class-name "text-xl text-center"}
       (loc/tr :import-step-success-text)]
    ]

     [:div
       {:class-name "flex justify-center"}
       [button/primary-solid
        {:href     (routing/path-for :import-data)
         :on-click (fn [e]
                     (.preventDefault e)
                     (.stopPropagation e)
                     (routing/set-view! [:import-data])
                     false)}
        (loc/tr :continue)]
     ]

     ]])
